import React, { Component, Fragment, memo } from 'react';
import { connect } from 'react-redux';

import { Notificacion } from '../../../../Util/Notificacion/Notificacion';
import { Obtener_Articulos_Orden_Request } from '../../../../../request/CallCenterMonitorRequest';

class DetalleArticulos extends Component {
    _isMounted = false;
    state = {
        articulos: []
    }

    componentDidMount() {
        this._isMounted = true;
        this.obtenerArticulos();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    obtenerArticulos = async () => {
        if (this.props.token) {
            const response = await Obtener_Articulos_Orden_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.esEcommerce, this.props.ordenGrupo);
            if (response.Exitoso) {
                this._isMounted && this.setState({ articulos: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    render() {
        const articulosFiltrados = this.state.articulos
            .filter((a) => a.Sucursal_Id === this.props.sucursalId || this.props.sucursalId === 0);

        let articulos = [];
        articulosFiltrados.reduce(function (res, value) {
            if (!res[value.Articulo_Id]) {
                res[value.Articulo_Id] = {
                    Articulo_Id: value.Articulo_Id,
                    Articulo_Nombre: value.Articulo_Nombre,
                    Articulo_Codigo_Principal: value.Articulo_Codigo_Principal,
                    Cantidad: 0,
                    Imagen_Path: value.Imagen_Path
                };
                articulos.push(res[value.Articulo_Id])
            }
            res[value.Articulo_Id].Cantidad += value.Cantidad
            return res;
        }, {});

        return (
            <Fragment>
                <button onClick={this.props.onClick}><span aria-hidden="true">×</span></button>
                <h4>{this.props.titulo}</h4>
                <div className="items-detail">
                    <table className="table-monitor">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Descripción</th>
                                <th className="text-right">Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                articulos.map((articulo, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="image text-center">
                                                <img src={articulo.Imagen_Path} alt="imagen artículo" />
                                            </td>
                                            <td>{`${articulo.Articulo_Codigo_Principal ? articulo.Articulo_Codigo_Principal : Articulo_Codigo_Principal.Articulo_Id} - ${articulo.Articulo_Nombre}`}</td>
                                            <td className="text-right">{articulo.Cantidad}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </Fragment>
        )
    }
}
const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(memo(DetalleArticulos));